import React from 'react';
import { Progress as AntProgress } from 'antd';
import PropTypes from 'prop-types';
import { useBrand } from 'modules/shared/brand/hooks/useBrand';
import { PLATFORM_COLOR } from '../../constants/colors';

const Progress = ({ percent }) => {
  const { brand } = useBrand();

  return (
    <div>
      <AntProgress
        type="line"
        strokeColor={PLATFORM_COLOR[brand]}
        percent={percent}
        width="100%"
        strokeLinecap="butt"
        showInfo={false}
      />
    </div>
  );
};

Progress.propTypes = {
  percent: PropTypes.number.isRequired,
  trailColor: PropTypes.string,
};

export default Progress;
